import React from "react";

import { useQuery } from "@tanstack/react-query";
import { ChartLine } from "lucide-react";
import { useTranslation } from "react-i18next";

import EncoderAPI from "../../api/EncoderAPI";
import prettyDurations, { padZero } from "../../utils/durations";

import type { JSX } from "react";

function ContentListQuota(): JSX.Element {
  const { t } = useTranslation("editor-content");

  const getEncodingPlanQuery = EncoderAPI.generateQuery({
    fn: EncoderAPI.getEncodingPlan,
    params: [],
  });

  const { data: encodingPlan } = useQuery(getEncodingPlanQuery);

  const encodingSec = encodingPlan?.encoding_sec ?? 0;
  const maxEncodingSec = encodingPlan?.max_encoding_sec ?? 0;

  const encodedUsed = prettyDurations(encodingSec, {
    valueUnit: "s",
  });
  const encodedTotal = prettyDurations(maxEncodingSec, {
    valueUnit: "s",
  });

  const quotaPercent =
    maxEncodingSec > 0 ? ((encodingSec / maxEncodingSec) * 100).toFixed(1) : 0;

  return (
    <div className="text-muted-foreground flex items-center gap-1 text-sm">
      <ChartLine aria-hidden="true" className="size-4.5 shrink-0" />
      <span>
        {t("quotas_helper", {
          used: `${encodedUsed.mod.hours}h${padZero(encodedUsed.mod.minutes)}mins`,
          total: `${encodedTotal.mod.hours}h${padZero(encodedTotal.mod.minutes)}mins`,
          percent: quotaPercent || 0,
        })}
      </span>
    </div>
  );
}

export default ContentListQuota;
